module.exports = __webpack_public_path__ + "static/media/eventTriggerSetting.8b19b678.graphql";